import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDioceseOrganizations } from '../../../global/ducks/organization-prc-api';
import { Role } from '../../../global/models/authenticated-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { setManageInstituionList } from '../features/institutions/institution-slice';


export function useManageInstitutionList() {
	const dispatch = useDispatch();
	const manageInstitutionListLoaded = useSelector<TcsmStates, boolean>(state => state.institutionState?.manageInstitutionListLoaded);
	const dios = useSelector<TcsmStates, Role[]>(state => state?.authenticatedState?.roleObject?.institution_roster);
	useEffect(() => {
		if (!manageInstitutionListLoaded) {
			const promises = [];
			dios?.forEach(dio => {
				promises.push(new Promise<any[]>(function (resolve) {
					dispatch(getDioceseOrganizations(
						dio?.role_target,
						(res) => {
							resolve(res?.data?.institutions?.organizations);
						},
						() => resolve([]),
					));
				}));
			});
			Promise.all(promises).then((res) => {
				dispatch(setManageInstituionList(
					res?.reduce(
						(accumulator, value) =>
							accumulator.concat(value), [])?.map(item => {
								return {
									legal_name: item?.organization_name,
									mailing_address: {
										city: item?.city,
									},
									...item,
								};
							},
							)));
			});
		}
	}, []);


	return manageInstitutionListLoaded;
}